<template lang="pug">
#admin_container.container-small
  h1#container_title 문의
  .container_wr
    #s41.sub
      .in
        select.s_tit(v-model='args.nation' @change='changeCat()')
          option(value='all') 전체
          option(value='kr') 한국어
          option(value='en') 영어
        .total_board_view_wrap
            #fboardlist
              table.board_list
                colgroup
                  col(width='70')
                  col(width='60' v-if="flagData.editFlag")
                  col
                  col(width='110')
                  col(width='110')
                tbody
                  tr
                    th.cursor_pointer(@click='toggleData("descList")') 번호
                    th(v-if="flagData.editFlag")
                      input(type='checkbox' @click='allCheck()')
                    th 제목
                    th 작성자
                    th 언어
                    th 날짜
                  tr(v-for="item in sortData" :key="item.idx" v-if="resData.leng !== 0")
                    td.num {{item.idx}}
                    td.checkbox(v-if="flagData.editFlag")
                      input(type='checkbox' v-model='checked' :value='item.idx')
                    td.subject
                      a(@click='goTo(item.idx)') {{item.name}}님의 문의
                    td.name {{item.name}}
                    td.name {{item.nation == 'EN' ? '영어' : '한국어'}}
                    td.datetime {{item.date}}
                  tr(v-if="resData.leng == 0")
                    td(colspan=5) 문의글이 없습니다.
        .edit_btn
          .board_button(v-if="!flagData.editFlag")
            a.newb(v-if="resData.leng !== 0" @click='toggleData("editFlag")') 편집
          .board_button(v-else)
            a(@click='delList()') 선택삭제
            a(@click='cancelEditing()') 취소
        nav.pg_wrap(v-if="resData.leng !== 0")
          span.pg
            a.pg_page.pg_start(@click='selectPage("prev")' v-if="resData.paging[2]")
            a.pg_page(v-for="(num, id) in pageNumber" :key="id" @click='selectPage(num)' :class='[page == num ? "pg_current" : ""]') {{num}}
            a.pg_page.pg_end(@click='selectPage("next")' v-if="resData.paging[3]")
    
    div(style="clear: both;")
    hr(style="margin: 30px 0;")
    
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      args: {
        nation: 'all',
      },
      page: '',
      pageNumber: [],
      flagData: {
        editFlag: false,
        allChecked: false,
        descList: true,
      },
      checked: [],
      resData: {
        leng: 0,
        data: [],
        paging: [],
      },
    };
  },
  computed: {
    ...mapGetters(['checkAdminPage']),
    sortData() {
      let arr = this.resData.data;
      if (this.flagData.descList) {
        // NOTE: 내림차순 3 2 1
        arr.sort(function (a, b) {
          return b.idx - a.idx;
        });
      } else {
        arr.sort(function (a, b) {
          return a.idx - b.idx;
        });
      }
      return arr;
    },
  },
  methods: {
    ...mapActions(['setPage', 'resetPage']),
    async getData() {
      this.page == '' ? (this.page = 1) : null;
      await this.$_admin_get('admin/contact/list', {
        page: this.page,
        nation: this.args.nation,
      }).then(res => {
        this.resData.data = res.data.res[0];
        this.resData.leng = this.resData.data.length;
        this.resData.paging = res.data.res[1];
        this.pageNumber = new Array(
          this.resData.paging[1] + 1 - this.resData.paging[0],
        )
          .fill(this.resData.paging[0])
          .map((n, i) => n + i);
      });
    },
    async delList() {
      if (this.checked.length !== 0) {
        let checkedParam = {
          id: this.checked.join(','),
        };
        await this.$_axios('PUT', 'admin/contact/del', checkedParam);
        this.getData();
      }
      this.cancelEditing();
    },
    changeCat() {
      this.setPage({ name: 'contact', page: 1, nation: this.args.nation });
      this.page = 1;
      this.getData();
    },
    selectPage(num) {
      if (this.flagData.editFlag) {
        this.cancelEditing();
      }
      if (num == 'prev') {
        this.page = this.resData.paging[0] - 1;
      } else if (num == 'next') {
        this.page = this.resData.paging[1] + 1;
      } else {
        this.page = num;
      }
      this.setPage({ name: 'contact', page: num, nation: this.args.nation });
      this.getData();
    },
    goTo(idx) {
      this.setPage({
        name: 'contact',
        page: this.page,
        nation: this.args.nation,
      });
      this.$_goTo({
        name: 'contact-detail-admin',
        params: { id: idx },
        query: { nation: this.args.nation },
      });
    },
    toggleData(value) {
      if (value == 'descList') {
        this.flagData.descList = !this.flagData.descList;
      } else if (value == 'editFlag') {
        this.flagData.editFlag = !this.flagData.editFlag;
      } else if (value == 'allChecked') {
        this.flagData.allChecked = !this.flagData.allChecked;
      }
    },
    allCheck() {
      this.toggleData('allChecked');
      if (this.flagData.allChecked) {
        let data = this.resData.data;
        let total = [];
        data.forEach(e => {
          total.push(e.idx);
        });
        this.checked = total;
      } else {
        this.checked = [];
      }
    },
    cancelEditing() {
      this.flagData.allChecked = false;
      this.flagData.editFlag = false;
      this.checked = [];
    },
  },
  mounted() {
    if (this.checkAdminPage.contact[0] !== 0) {
      this.page = this.checkAdminPage.contact[0];
      this.args.nation = this.checkAdminPage.contact[1];
    }
    this.getData();
    this.resetPage();
  },
  created() {},
};
</script>

<style scoped>
@import '../../../assets/css/admin.css';
@import '../../../assets/css/contact-fir.css';
@import '../../../assets/css/contact-sec.css';
#s41.sub {
  padding: 0;
  padding-top: 30px;
}
td.datetime {
  width: 110px;
}
.pg_current {
  width: 30px;
  cursor: default;
  display: inline-block;
  background: #333;
  border: 1px solid #333;
  color: #fff;
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  min-width: 30px;
  border-radius: 3px;
}
.cursor_pointer {
  cursor: pointer;
}
.board_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
}
.board_button a {
  padding: 5px 15px;
  border: 1px solid #ccc;
  line-height: 100%;
  margin-left: 5px;
  color: #555;
  cursor: pointer;
}
.board_button a.newb {
  background: #4b545e;
  color: #fff;
  cursor: pointer;
}
a,
a:link {
  color: #555;
  text-decoration: none;
  cursor: pointer;
}
.wrap #wrap_sub .sub_right {
  padding: 120px 0;
}
@media (max-width: 1024px) {
  .sub_right {
    padding: 100px 0;
  }
}
@media (max-width: 768px) {
  .sub_right {
    padding: 80px 0;
  }
}
</style>
